import Image from "@Components/Image";
import styles from "./NoAccommodationCard.module.scss";
import { BASE_IMG_URL } from "constants/configConstants";
import useIsApp from "hooks/useIsApp";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

function NoAccommodationCard(): JSX.Element {
  const isApp = useIsApp();
  const { t } = useTranslationHook();
  if (!isApp) return <></>;

  const title = t("searchpage.components.searchlist.components.noaccommodationcard.title");
  const description = `${t(
    "searchpage.components.searchlist.components.noaccommodationcard.subtitleprefix",
  )} ${t("searchpage.components.searchlist.components.noaccommodationcard.subtitlesuffix")}`;
  return (
    <div className={styles.noResultContainer}>
      <Image
        src={`${BASE_IMG_URL}no_results_icon.svg`}
        alt="no result icon"
        height={90}
        width={90}
      />
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{description}</p>
    </div>
  );
}
export default wrapperHOC(NoAccommodationCard, {
  componentName: "NoAccommodationCard-SearchListWebViewApp-SearchPage",
});
